import React from 'react';

export default function StagingSummaryBlock({ count, onEditSelection }) {
    if (count === 0) return null;

    return (
        <div style={{
            padding: '8px 12px', marginBottom: 8, fontSize: 13,
            background: '#FAFBFC', borderRadius: 6, border: '1px solid #E8EAED',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
            <span style={{ color: '#5F6368' }}>
                {count} recipient{count !== 1 ? 's' : ''} staged for dispatch
            </span>
            {onEditSelection && (
                <button
                    onClick={onEditSelection}
                    style={{
                        background: 'none', border: 'none', color: '#1967D2',
                        fontSize: 12, cursor: 'pointer', textDecoration: 'underline',
                        padding: 0,
                    }}
                >Edit selection</button>
            )}
        </div>
    );
}
